module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/DVD-91299f08d4691b1603c7c782f45ee756.svg";